exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".title-section {\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.custom-block {\r\n  background-color: white;\r\n}\r\n\r\nth {\r\n  text-align: left;\r\n}\r\n\r\ntable {\r\n  border-collapse: collapse;\r\n  font-size: 12px;\r\n}\r\n\r\n.update-btn {\r\n  margin-left: 1%;\r\n  height: 40%;\r\n  background-color: #115E67;\r\n  border-color: transparent;\r\n}\r\n\r\n.export-btn {\r\n  margin-left: 1%;\r\n  height: 40%;\r\n  background-color: #115E67;\r\n  border-color: transparent;\r\n}\r\n\r\n.default-btn {\r\n  background-color: white;\r\n  border: 1px solid rgba(0, 0, 0, 0.15);\r\n  margin-left: 5px;\r\n}\r\n\r\n.reset-btn {\r\n  margin-left: .5%;\r\n  height: 40%;\r\n  color: black;\r\n  background-color: white;\r\n}\r\n\r\n.table td {\r\n  padding: 0.60rem;\r\n}\r\n\r\n.title-description {\r\n  font-size: 12px;\r\n}\r\n\r\n.title {\r\n  font-size: 18px;\r\n}\r\n\r\n.pointer{\r\n  cursor: pointer;\r\n}\r\n\r\n.mat-input-container {\r\n  width: 12%;\r\n  margin: 0 10px 0 10px;\r\n}\r\n\r\n@media (max-width: 786px) {\r\n  .mat-input-container {\r\n    width: 35%;\r\n    margin: 0 10px 0 10px;\r\n  }\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/payroll-log/payroll-log.component.css
// module id = 348
// module chunks = 1